import { withInstall } from '@mts-fe/utils';
import _BatchUpload from './src/BatchUpload.vue';
import _ImagePaste from './src/ImagePaste.vue';
import _MUpload from './src/MUpload.vue';

export * from './src/types';
export const MUpload = withInstall(_MUpload);
export const ImagePaste = withInstall(_ImagePaste);
export const BatchUpload = withInstall(_BatchUpload);
